import { request } from '../utils/request';

export const fetchHubsWithSurvey = () =>
  request.get('/superadmin/surveys-provisioning/hub-surveys');

export const addNewSurveyTemplate = data =>
  request.post('/superadmin/surveys-provisioning/add', data);

export const updateSurveyTemplate = data =>
  request.put('/superadmin/surveys-provisioning/update', data);

export const deleteSurveyTemplateById = id =>
  request.delete(`/superadmin/surveys-provisioning/${id}`);

